import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArtigoPage from "../pages/artigo/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guia-hoobuy-spreadsheet",
    element: <Navigate to="/artigo/guia-hoobuy-spreadsheet" replace />,
  },
  {
    path: "/artigo/:slug",
    element: <ArtigoPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;